import React from 'react';
import { Col, Image } from 'react-bootstrap';
import featuresLogo from '../../assets/images/22x.png';
import featuresMobile from '../../assets/images/mobile.png';
import featuresEnvelop from '../../assets/images/envelop.png';
import featuresDeliver from '../../assets/images/deliver.png';
import featuresKnob from '../../assets/images/knob.png';

import featuresPhone from '../../assets/images/phone.png';
import featuresPhone2 from '../../assets/images/phone-tablet.png';
import featuresPhone3 from '../../assets/images/phone-mobile.jpg';

const MobileApp = () => (
  <div className="show-grid">
    <div className="main-mobile-grid">
      <Col md={12} className="mobile-col">
        <h2>Features</h2>
        <p>Quality content. Mobile convenience.</p>
      </Col>
      <Col md={12} className="for-tablet-grid">
        <div className="for-mobile-grid">
          <Col md={4} className="first-mobile-grid">
            <div className="local-phone-block">
              <Col md={12} className="main-mobilegrid-block">
                <div className="img-mobile-grid mobile-icon">
                  <Image src={featuresMobile} />
                </div>
                <div className="block-mobile-grid">
                  <h3 className="mobile-h3-grid">With You</h3>
                  <p>
                    Leverage the presence of you phone to help you practice the presence of God. Get immediate access to
                    your exercises in moments when a computer or book won't do.
                  </p>
                </div>
              </Col>
              <Col md={12} className="main-mobilegrid-block">
                <div className="img-mobile-grid deliver-icon">
                  <Image src={featuresDeliver} />
                </div>
                <div className="block-mobile-grid">
                  <h3 className="mobile-h3-grid">For You</h3>
                  <p>
                    Important. Fruitful. Enjoyable. The Presence mobile app helps you cultivate awareness of God in
                    order to live an abundant life.
                  </p>
                </div>
              </Col>
            </div>
          </Col>
          <Col md={4} className="second-mobile-grid">
            <div className="img-phone-grid">
              <a
                href="https://itunes.apple.com/us/app/presence-walk-with-god/id1400174335?l=ru&ls=1&mt=8"
                target="_blank"
              >
                <Image className="img-phone-main" src={featuresPhone} />
                <Image className="img-phone-tablet" src={featuresPhone2} />
              </a>
            </div>
          </Col>
          <Col md={4} className="third-mobile-grid">
            <div className="local-phone-block">
              <Col md={12} className="main-mobilegrid-block">
                <div className="img-mobile-grid envelop-icon">
                  <Image src={featuresEnvelop} />
                </div>
                <div className="block-mobile-grid">
                  <h3 className="mobile-h3-grid">To You</h3>
                  <p>
                    Automated delivery means no more forgetting and no more needless steps. Don’t worry about what’s
                    next—the Presence app brings it to you.
                  </p>
                </div>
              </Col>
              <Col md={12} className="main-mobilegrid-block">
                <div className="img-mobile-grid knob-icon">
                  <Image src={featuresKnob} />
                </div>
                <div className="block-mobile-grid">
                  <h3 className="mobile-h3-grid">By You</h3>
                  <p>
                    Experiment across 8 categories and choose which exercises fit your personality, schedule, or season
                    in life. Explore which additional resources you want to add to your personal tool kit as you
                    increase your God-given capacity to know Him more.
                  </p>
                </div>
              </Col>
            </div>
          </Col>
        </div>
      </Col>
      <Col md={12} className="fourth-mobile-grid">
        <div className="fourth-phone-grid">
          <a href="https://itunes.apple.com/us/app/presence-walk-with-god/id1400174335?l=ru&ls=1&mt=8" target="_blank">
            <Image className="img-phone-mobile" src={featuresPhone3} />
          </a>
        </div>
      </Col>
    </div>
  </div>
);

export default MobileApp;



// WEBPACK FOOTER //
// ./src/components/Landing/MobileApp.js